module.exports = __webpack_public_path__ + "img/KG.965d1bc2.svg";